import { cn } from '@nexelem/utils';
import { VariantProps, cva } from 'class-variance-authority';

const indicatorVariants = cva('shadow-tiny', {
  variants: {
    variant: {
      dot: 'h-2 w-2 rounded-full',
      number:
        'flex h-3.5 min-w-3 items-center justify-center rounded-md px-2 py-1 text-s11-sb text-text-primary-inverse',
    },
    status: {
      default: 'bg-surface-brand-darker',
      success: 'bg-surface-status-green-darker',
      warning: 'bg-surface-status-orange-darker',
      info: 'bg-surface-status-navy-darker',
      error: 'bg-surface-status-red-darker',
    },
  },
  defaultVariants: {
    variant: 'dot',
    status: 'default',
  },
});

type IndicatorVariants = VariantProps<typeof indicatorVariants>;

export type IndicatorProps = IndicatorVariants & {
  className?: string;
  count?: number | string;
  isCountLimit?: boolean;
  countLimit?: number;
};

export const Indicator = ({ count, status, className, isCountLimit = false, countLimit = 99 }: IndicatorProps) => {
  const countContent = typeof count === 'number' && isCountLimit && count > countLimit ? `${countLimit}+` : count;

  return (
    <div
      className={cn(
        indicatorVariants({ status, variant: countContent !== undefined && Number(count) >= 1 ? 'number' : 'dot' }),
        className,
      )}
    >
      {Number(count) >= 1 && countContent}
    </div>
  );
};
